import { render } from "./DevToolsPage.vue?vue&type=template&id=7afd1c70&ts=true"
import script from "./DevToolsPage.vue?vue&type=script&lang=ts"
export * from "./DevToolsPage.vue?vue&type=script&lang=ts"

import "./DevToolsPage.vue?vue&type=style&index=0&id=7afd1c70&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__